/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_PrivacyInputs */

const zh_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const en_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

const es_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Landing_Footer_PrivacyInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_footer_privacy = /** @type {((inputs?: Landing_Footer_PrivacyInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_PrivacyInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_footer_privacy(inputs)
	if (locale === "en") return en_landing_footer_privacy(inputs)
	return es_landing_footer_privacy(inputs)
});